export const BASE_URL = 'https://mynewbackend-c2rj.onrender.com/';
//https://mynewbackend-c2rj.onrender.com/
//http://localhost:5000/
